<template>
    <div class="box">
        <div class="field">
            <label class="label">Due Date</label>
            <div class="control">
                <input v-model="dueDate" type="date" class="input"/>
            </div>
        </div>
        <div class="field">
            <label class="label">Beneficiary ID</label>
            <div class="control">
                <input v-model="beneficiaryID" class="input" type="number">
            </div>
        </div>
        <label class="label">Reminder note</label>
        <textarea v-model="reminderNote" class="textarea block"></textarea>
        <div class="align-center">
            <button class="button is-rounded is-info">Save</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dueDate: null,
            beneficiaryID: null,
            reminderNote: null
        }
    }
}
</script>